/**
 * PaymentRequest entity class
 */

// import { pickId } from 'app/helpers/entity'

/**
 * PaymentRequestFactory
 * returns PaymentRequest entity class
 *
 * @class PaymentRequestFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.PaymentRequest} class
 *
 * @ngdoc factory
 * @name mwApp.factory:PaymentRequestFactory
 */
/* @ngInject */

export default function PaymentRequestFactory ($http, Entity) {
  /* === PaymentRequest class === */

  /**
   * PaymentRequest model
   *
   * @class PaymentRequest
   * @classdesc PaymentRequest model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.PaymentRequest} PaymentRequest entity
   */
  function PaymentRequest () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  PaymentRequest.prototype = Object.create(Entity.prototype)
  PaymentRequest.prototype.constructor = PaymentRequest

  /* === PaymentRequest instance methods & fields === */

  Object.assign(PaymentRequest.prototype, {

    /**
     * instance fields
     *
     * @memberof models.PaymentRequest#
     * @type {Object}
     */
    _fields: {
      // General payment fields
      approvalRequired: false,
      currencyConverterType: String, // CURRENCY_CONVERTER_TYPES
      currencyId: Number,
      paymentKey: String,
      subscriberId: Number,

      // Fields related to payment type
      autoPay: false,
      comment: String,
      contentAddonsAutoPay: false,
      devicesToPay: Number,
      length: Number,
      lengthType: String, // SubscriptionLengthType,
      override: true,
      paymentType: String, // PAYMENT_TYPES
      price: Number,
      prorateToUpcoming: true,
      prorateSubscription: false,
      subscriptionId: Number,
      subscription: {
        initialSubTotal: Number,
        subTotal: Number
      },
      contentAddOns: {
        initialSubTotal: Number,
        subTotal: Number
      },
      contentSetAddOns: [
        {
          $adjustEnabled: Boolean,
          autoPay: false,
          id: Number,
          name: String,
          contentType: String,
          currency: 'Currency',
          extraLength: Number,
          priceType: String,
          subscriptionId: Number,
          amount: Number
        }
      ],
      trial: Boolean,
      transactionFeeAmount: Number,

      // Fields related to payment system type
      checkNumber: String,
      creditCardId: Number,
      externalPaymentSystemType: String, // EXTERNAL_PAYMENT_SYSTEM_TYPES
      paymentSystemType: String, // PAYMENT_SYSTEM_TYPES
      transactionId: String,
      location: 'Location',
      accessoryIds: [Number],
      $adjustEnabled: Boolean,
      $adjustType: String,
      $extraLength: Number
    },

    /**
     * url template
     *
     * @memberof models.PaymentRequest#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{::subscriberId}}/payments',

    /**
     * Calculate payment cost, performing PUT/POST request to backend
     *
     * @memberof models.PaymentRequest#
     * @param {Function} [mapFunc] - map function, it is possible to transform underlying object before request
     * @return {Promise} promise
     */
    _calculate: function (mapFunc) {
      return Entity.prototype._save.call(this, mapFunc, this._url + '/calculate', null)
    }
  })

  /* === PaymentRequest static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(PaymentRequest, Entity)
  PaymentRequest._name = 'PaymentRequest'
  PaymentRequest.init()

  // permissions
  PaymentRequest.access = {
    view: 'viewSubscriptionPayment',
    create: 'createSubscriptionPayment'
  }

  return PaymentRequest
}
